/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_StrengthInputs */

const en_us2_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · strength`)
};

const pt_br2_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · força`)
};

const es_419_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · fuerza`)
};

const pt_pt2_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · força`)
};

const fr_fr2_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · force`)
};

const de_de2_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · Kraft`)
};

const it_it2_progress_extra_rep_strength = /** @type {(inputs: Progress_Extra_Rep_StrengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1–5 · forza`)
};

/**
* | output |
* | --- |
* | "1–5 · strength" |
*
* @param {Progress_Extra_Rep_StrengthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_strength = /** @type {((inputs?: Progress_Extra_Rep_StrengthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_StrengthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_strength(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_strength(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_strength(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_strength(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_strength(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_strength(inputs)
	return en_us2_progress_extra_rep_strength(inputs)
});
export { progress_extra_rep_strength as "progress-extra.rep_strength" }